<main class="main-scroll" vid="14">

    <div class="segment-container" vid="15">
        <div class="segment-btn active" vid="16">Dropoff</div>
        <div class="segment-btn" vid="17">Details</div>
    </div>

    <section class="destination-info" vid="18">
        <h1 class="address-title" vid="19">{{ delivery?.address?.line1 || 'Line 1' }}</h1>
        <div class="address-sub" vid="20">{{ delivery?.address?.line2 || 'Line 2' }}, {{ delivery?.address?.city ||
            'City' }}</div>
    </section>

    <section class="map-pill" vid="21">
        <p>map</p>
        <mgl-map [mapStyle]="
        'https://tiles.openfreemap.org/styles/liberty'
      " [zoom]="[13]" [center]="[11.255, 43.77]">

        </mgl-map>

        <!--
            <div class="map-pattern" vid="22"></div>
            <div class="map-route-line" vid="23"></div>
            <div class="map-pin" vid="24"></div>
            <div class="nav-overlay-btn" vid="25">
                <svg width="14" height="14" viewBox="0 0 24 24" vid="26">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" vid="27"></path>
                    <polyline points="9 22 9 12 15 12 15 22" vid="28"></polyline>
                </svg>
                navigate
            </div>
            -->
    </section>

    <section class="list-section" vid="29">
        <div class="section-header text-muted" vid="30">
            <div class="section-title" vid="31">
                <svg width="16" height="16" viewBox="0 0 24 24" vid="32">
                    <path d="M21 8v13H3V8" vid="33"></path>
                    <path d="M1 3h22v5H1z" vid="34"></path>
                    <path d="M10 12h4" vid="35"></path>
                </svg>
                <span vid="36">Packages</span>
            </div>
            <svg width="16" height="16" viewBox="0 0 24 24" vid="37">
                <circle cx="12" cy="12" r="10" vid="38"></circle>
                <line x1="12" y1="8" x2="12" y2="16" vid="39"></line>
                <line x1="8" y1="12" x2="16" y2="12" vid="40"></line>
            </svg>
        </div>

        <div class="pill-list" vid="41">

            <div class="pill-item" vid="42" *ngFor="let item of delivery.items">
                <div class="pill-avatar avatar-dark" vid="43">
                    <img [src]="item.url" width="20" height="20" viewBox="0 0 24 24" vid="44" />
                </div>
                <div class="pill-content" vid="48">
                    <div class="pill-title" vid="49">{{ item.name }}</div>
                    <div class="text-xs text-muted mono" vid="50">id: 8842 • 15kg</div>
                </div>
                <div class="pill-action" vid="51">
                    <svg width="20" height="20" viewBox="0 0 24 24" vid="52">
                        <circle cx="12" cy="12" r="1" vid="53"></circle>
                        <circle cx="19" cy="12" r="1" vid="54"></circle>
                        <circle cx="5" cy="12" r="1" vid="55"></circle>
                    </svg>
                </div>
            </div>


        </div>
    </section>

</main>

<div class="bottom-fixed-area" vid="69">
    <div class="status-row text-xs text-muted mono" vid="70">
        <span vid="71">route_active.nav</span>
        <span vid="72">ETA / {{ delivery.eta }}</span>
    </div>

    <div class="texture-line" vid="73"></div>

    <div class="action-grid" vid="74">
        <div class="grid-cell" vid="75">
            <span class="action-btn-text" vid="76">Aa</span>
        </div>

        <div class="grid-cell main-action" vid="77">

            <div class="red-dot-btn" vid="78">
                <div class="red-dot" vid="79"></div>
                <span vid="80">arrive</span>
            </div>
        </div>

        <div class="grid-cell" vid="81">
            <svg width="22" height="22" viewBox="0 0 24 24" style="color: var(--text-muted);" vid="82">
                <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    vid="83"></path>
            </svg>
        </div>
    </div>
</div>